import type { CalendarViewBooking } from '../calendarView.types';
import { AirbnbIcon } from '../../../components/icons/AirbnbIcon';

export function bookingOriginTitle(booking: {
  bookingOrigin?: CalendarViewBooking['bookingOrigin'];
  otaChannel?: CalendarViewBooking['otaChannel'];
  conversationChannel?: CalendarViewBooking['conversationChannel'];
}): string {
  if (booking.bookingOrigin === 'ota') {
    const ch = booking.otaChannel ?? 'other';
    const labels: Record<string, string> = {
      airbnb: 'Airbnb',
      booking: 'Booking.com',
      vrbo: 'Vrbo',
      expedia: 'Expedia',
      other: 'OTA',
    };
    return labels[ch] ?? labels.other;
  }
  return 'Interactive Talker';
}

export function BookingOriginIcon({
  bookingOrigin,
  otaChannel,
  size = 12,
}: {
  bookingOrigin?: CalendarViewBooking['bookingOrigin'];
  otaChannel?: CalendarViewBooking['otaChannel'];
  conversationChannel?: CalendarViewBooking['conversationChannel'];
  size?: number;
}) {
  if (bookingOrigin === 'ota') {
    if (otaChannel === 'airbnb') {
      return <AirbnbIcon size={size} />;
    }
    return (
      <span style={{ fontSize: 9, lineHeight: 1, flexShrink: 0 }} aria-hidden>
        🌐
      </span>
    );
  }
  return (
    <span
      title="Interactive Talker"
      aria-label="Interactive Talker"
      role="img"
      style={{ display: 'inline-flex', flexShrink: 0 }}
    >
      <img
        src="/logo.png"
        alt=""
        width={size}
        height={size}
        style={{ display: 'block', objectFit: 'contain' }}
      />
    </span>
  );
}
